"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font = void 0;
exports.getFont = getFont;
exports.stringToFontStrokes = stringToFontStrokes;
const newstroke_1 = require("./KicadNewstroke/newstroke");
var Font;
(function (Font) {
    Font["Newstroke"] = "newstroke";
})(Font || (exports.Font = Font = {}));
function getFont(font) {
    if (font === Font.Newstroke) {
        return {
            startChar: 0x20,
            heightRatio: 4 / 3,
            unknownChar: 'F^K[KFYFY[K[',
            fontRenderScale: 1 / 21,
            italicTilt: 1 / 8,
            charSpacing: 0,
            overbarSpacing: 0.1,
            underlineSpacing: 0.1,
            interlineRatio: 1.62,
            fontRenderOffset: [-'R'.charCodeAt(0), -'R'.charCodeAt(0) + 10 + 3],
            glyphs: newstroke_1.newstroke_font,
        };
    }
    throw new Error('Unknown font: ' + font);
}
function stringToFontStrokes(font, str) {
    const strokes = [];
    for (let i = 0; i < str.length; ++i) {
        const charCode = str.charCodeAt(i);
        let baseCode = Number.NEGATIVE_INFINITY;
        for (let code of Object.keys(font.glyphs)) {
            if (typeof code === 'string') {
                code = parseInt(code);
            }
            if (code > charCode) {
                break;
            }
            baseCode = code;
        }
        if (baseCode < 0) {
            strokes.push(font.unknownChar);
            continue;
        }
        const glyphPack = font.glyphs[baseCode];
        if (charCode >= baseCode + glyphPack.length) {
            strokes.push(font.unknownChar);
            continue;
        }
        strokes.push(glyphPack[charCode - baseCode]);
    }
    return strokes;
}
//# sourceMappingURL=fonts.js.map